import { Modal } from "antd"
import styled from "styled-components"

export const ModalWrapper = styled(Modal)`
  /* .ant-modal-root .ant-modal-header {
    background-color: #d3f7ff;
  }

  .ant-modal-body {
    flex: auto;
    overflow: ${props => (props.hiddenScroll ? "hidden" : "hidden auto")};
  } */
`
